import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCvF7UfUwnn8lG0zDuRPBy31SpWudFDLL8",
  authDomain: "talentsync-ebafe.firebaseapp.com",
  projectId: "talentsync-ebafe",
  storageBucket: "talentsync-ebafe.firebasestorage.app",
  messagingSenderId: "590677221799",
  appId: "1:590677221799:web:bdb3e0d717d4c52877d682",
  measurementId: "G-C6R115LTVE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const messaging = getMessaging(app);
export const requestForToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: "BBXrPez728BG3UM2JsB0ALnefdYJw08AkV_NXVG_nBfwb22_gcvxjfzdVz7DtRnGEl1YOwt_uUQ5bp_tQ0jh8b4",
      });
      if (token) {
        console.log("FCM Token:", token);
        return token;
      } else {
        console.log("No registration token available. Request permission to generate one.");
      }
    } else {
      console.log("Notification permission not granted.");
    }
  } catch (error) {
    console.error("An error occurred while retrieving token. ", error);
  }
  return null;
};

onMessage(messaging, (payload) => {
  console.log('Message received. ', payload);
  const notificationTitle = payload.data?.title || 'Notification';
  const notificationOptions = {
    body: payload.data?.body,
    icon: '/firebase-logo.png'
  };

  if (Notification.permission === 'granted') {
    new Notification(notificationTitle, notificationOptions);
  }
});
